import { SelectOption } from '~/shared/utils/types';
import SidePanel from '~/shared/components/SidePanel';
import FilterPanelHeader from '~/shared/components/filters/FilterPanelHeader';
import FilterActions from '~/shared/components/filters/FilterActions';

import { useFilterState, useFilterUrlParams } from './hooks';
import FilterPanelContent from './FilterPanelContent';

export type GroupFleetManagerSelectionOption = {
  label: string;
  options: SelectOption[];
};

interface AllVolumesFiltersSidePanelProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onResetFilters?: () => void;
  appliedClusterNameFilters: SelectOption[];
  appliedInstanceFilters: SelectOption[];
  appliedVolumeIdFilters: SelectOption[];
  appliedVolumeTagFilters: SelectOption[];
  appliedAutoscaleState: string[];
}

export default function AllVolumesFiltersSidePanel({
  open,
  onOpenChange,
  onResetFilters,
  appliedClusterNameFilters,
  appliedInstanceFilters,
  appliedVolumeIdFilters,
  appliedVolumeTagFilters,
  appliedAutoscaleState,
}: AllVolumesFiltersSidePanelProps) {
  const { applyFilters, resetFilters } = useFilterUrlParams();

  const filterState = useFilterState({
    open,
    appliedClusterNameFilters,
    appliedInstanceFilters,
    appliedVolumeIdFilters,
    appliedVolumeTagFilters,
    appliedAutoscaleState,
  });

  const handleResetFilters = () => {
    if (onResetFilters) {
      onResetFilters();
    } else {
      filterState.resetPendingFilters();
      resetFilters();
    }
  };

  const handleApplyFilters = () => {
    applyFilters(
      filterState.pendingAutoscaleState,
      filterState.pendingClusterNameFilters,
      filterState.pendingVolumeIdFilters,
      filterState.pendingVolumeTagFilters,
      filterState.pendingInstanceFilters
    );
  };

  return (
    <SidePanel open={open} onOpenChange={onOpenChange} width="w-[587px]">
      <div className="flex flex-col h-full">
        <FilterPanelHeader />

        <FilterPanelContent
          panelOpen={open}
          pendingAutoscaleState={filterState.pendingAutoscaleState}
          setPendingAutoscaleState={filterState.setPendingAutoscaleState}
          pendingClusterNameFilters={filterState.pendingClusterNameFilters}
          setPendingClusterNameFilters={filterState.setPendingClusterNameFilters}
          pendingInstanceFilters={filterState.pendingInstanceFilters}
          setPendingInstanceFilters={filterState.setPendingInstanceFilters}
          pendingVolumeIdFilters={filterState.pendingVolumeIdFilters}
          setPendingVolumeIdFilters={filterState.setPendingVolumeIdFilters}
          pendingVolumeTagFilters={filterState.pendingVolumeTagFilters}
          setPendingVolumeTagFilters={filterState.setPendingVolumeTagFilters}
        />

        <FilterActions
          onReset={handleResetFilters}
          onApply={handleApplyFilters}
          onClose={() => onOpenChange(false)}
          hasActiveFilters={
            filterState.pendingAutoscaleState.length > 0 ||
            filterState.pendingClusterNameFilters.length > 0 ||
            filterState.pendingVolumeIdFilters.length > 0 ||
            filterState.pendingVolumeTagFilters.length > 0 ||
            filterState.pendingInstanceFilters.length > 0
          }
        />
      </div>
    </SidePanel>
  );
}
